import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "countdown",
    pure: true,
    standalone: true
})
export class CountdownPipe implements PipeTransform {
    transform(text: string, args: number): number {
        let maxLength: number = args || 0;
        let length: number = text.length;

        return (maxLength - length);
    }
}